'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var PeerId = require('peer-id');

var key = require('interface-datastore/key');

var Errors = require('datastore-core/errors');

var errCode = require('err-code');

var debug = require('debug');

var toString = require('uint8arrays/to-string');

var equals = require('uint8arrays/equals');

var ipns = require('ipns');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var ipns__namespace = /*#__PURE__*/_interopNamespace(ipns);

var log = Object.assign(debug__default["default"]('ipfs:ipns:publisher'), {
  error: debug__default["default"]('ipfs:ipns:publisher:error')
});
var ERR_NOT_FOUND = Errors.notFoundError().code;
var defaultRecordLifetime = 60 * 60 * 1000;

var IpnsPublisher = /*#__PURE__*/function () {
  function IpnsPublisher(routing, datastore) {
    _classCallCheck(this, IpnsPublisher);

    this._routing = routing;
    this._datastore = datastore;
  }

  _createClass(IpnsPublisher, [{
    key: "publishWithEOL",
    value: function () {
      var _publishWithEOL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(privKey, value, lifetime) {
        var peerId, record;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!privKey || !privKey.bytes)) {
                  _context.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('invalid private key'), 'ERR_INVALID_PRIVATE_KEY');

              case 2:
                _context.next = 4;
                return PeerId__default["default"].createFromPrivKey(privKey.bytes);

              case 4:
                peerId = _context.sent;
                _context.next = 7;
                return this._updateOrCreateRecord(privKey, value, lifetime, peerId);

              case 7:
                record = _context.sent;
                return _context.abrupt("return", this._putRecordToRouting(record, peerId));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function publishWithEOL(_x, _x2, _x3) {
        return _publishWithEOL.apply(this, arguments);
      }

      return publishWithEOL;
    }()
  }, {
    key: "publish",
    value: function publish(privKey, value) {
      return this.publishWithEOL(privKey, value, defaultRecordLifetime);
    }
  }, {
    key: "_putRecordToRouting",
    value: function () {
      var _putRecordToRouting2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(record, peerId) {
        var errMsg, publicKey, embedPublicKeyRecord, keys;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (PeerId__default["default"].isPeerId(peerId)) {
                  _context2.next = 4;
                  break;
                }

                errMsg = 'peerId received is not valid';
                log.error(errMsg);
                throw errCode__default["default"](new Error(errMsg), 'ERR_INVALID_PEER_ID');

              case 4:
                publicKey = peerId._pubKey;
                _context2.next = 7;
                return ipns__namespace.embedPublicKey(publicKey, record);

              case 7:
                embedPublicKeyRecord = _context2.sent;
                keys = ipns__namespace.getIdKeys(peerId.toBytes());
                _context2.next = 11;
                return this._publishEntry(keys.routingKey, embedPublicKeyRecord || record);

              case 11:
                _context2.next = 13;
                return this._publishPublicKey(keys.routingPubKey, publicKey);

              case 13:
                return _context2.abrupt("return", embedPublicKeyRecord || record);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _putRecordToRouting(_x4, _x5) {
        return _putRecordToRouting2.apply(this, arguments);
      }

      return _putRecordToRouting;
    }()
  }, {
    key: "_publishEntry",
    value: function () {
      var _publishEntry2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key$1, entry) {
        var k, errMsg, entryData, res, _errMsg;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                k = key.Key.asKey(key$1);

                if (k) {
                  _context3.next = 5;
                  break;
                }

                errMsg = 'datastore key does not have a valid format';
                log.error(errMsg);
                throw errCode__default["default"](new Error(errMsg), 'ERR_INVALID_DATASTORE_KEY');

              case 5:
                _context3.prev = 5;
                entryData = ipns__namespace.marshal(entry);
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](5);
                log.error(_context3.t0);
                throw _context3.t0;

              case 13:
                _context3.prev = 13;
                _context3.next = 16;
                return this._routing.put(k.uint8Array(), entryData);

              case 16:
                res = _context3.sent;
                log("ipns record for ".concat(toString.toString(k.uint8Array(), 'base64'), " was stored in the routing"));
                return _context3.abrupt("return", res);

              case 21:
                _context3.prev = 21;
                _context3.t1 = _context3["catch"](13);
                _errMsg = "ipns record for ".concat(toString.toString(k.uint8Array(), 'base64'), " could not be stored in the routing");
                log.error(_errMsg);
                log.error(_context3.t1);
                throw errCode__default["default"](new Error(_errMsg), 'ERR_PUTTING_TO_ROUTING');

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 9], [13, 21]]);
      }));

      function _publishEntry(_x6, _x7) {
        return _publishEntry2.apply(this, arguments);
      }

      return _publishEntry;
    }()
  }, {
    key: "_publishPublicKey",
    value: function () {
      var _publishPublicKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key$1, publicKey) {
        var k, errMsg, _errMsg2, res, _errMsg3;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                k = key.Key.asKey(key$1);

                if (k) {
                  _context4.next = 5;
                  break;
                }

                errMsg = 'datastore key does not have a valid format';
                log.error(errMsg);
                throw errCode__default["default"](new Error(errMsg), 'ERR_INVALID_DATASTORE_KEY');

              case 5:
                if (!(!publicKey || !publicKey.bytes)) {
                  _context4.next = 9;
                  break;
                }

                _errMsg2 = 'one or more of the provided parameters are not defined';
                log.error(_errMsg2);
                throw errCode__default["default"](new Error(_errMsg2), 'ERR_UNDEFINED_PARAMETER');

              case 9:
                _context4.prev = 9;
                _context4.next = 12;
                return this._routing.put(k.uint8Array(), publicKey.bytes);

              case 12:
                res = _context4.sent;
                log("public key for ".concat(toString.toString(k.uint8Array(), 'base64'), " was stored in the routing"));
                return _context4.abrupt("return", res);

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](9);
                _errMsg3 = "public key for ".concat(toString.toString(k.uint8Array(), 'base64'), " could not be stored in the routing");
                log.error(_errMsg3);
                log.error(_context4.t0);
                throw errCode__default["default"](new Error(_errMsg3), 'ERR_PUTTING_TO_ROUTING');

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[9, 17]]);
      }));

      function _publishPublicKey(_x8, _x9) {
        return _publishPublicKey2.apply(this, arguments);
      }

      return _publishPublicKey;
    }()
  }, {
    key: "_getPublished",
    value: function () {
      var _getPublished2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(peerId) {
        var options,
            errMsg,
            checkRouting,
            dsVal,
            _errMsg4,
            keys,
            res,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};

                if (PeerId__default["default"].isPeerId(peerId)) {
                  _context5.next = 5;
                  break;
                }

                errMsg = 'peerId received is not valid';
                log.error(errMsg);
                throw errCode__default["default"](new Error(errMsg), 'ERR_INVALID_PEER_ID');

              case 5:
                checkRouting = options.checkRouting !== false;
                _context5.prev = 6;
                _context5.next = 9;
                return this._datastore.get(ipns__namespace.getLocalKey(peerId.id));

              case 9:
                dsVal = _context5.sent;
                return _context5.abrupt("return", this._unmarshalData(dsVal));

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](6);

                if (!(_context5.t0.code !== ERR_NOT_FOUND)) {
                  _context5.next = 19;
                  break;
                }

                _errMsg4 = "unexpected error getting the ipns record ".concat(peerId.id, " from datastore");
                log.error(_errMsg4);
                throw errCode__default["default"](new Error(_errMsg4), 'ERR_UNEXPECTED_DATASTORE_RESPONSE');

              case 19:
                if (checkRouting) {
                  _context5.next = 21;
                  break;
                }

                throw errCode__default["default"](_context5.t0, 'ERR_NOT_FOUND_AND_CHECK_ROUTING_NOT_ENABLED');

              case 21:
                _context5.prev = 21;
                keys = ipns__namespace.getIdKeys(peerId.toBytes());
                _context5.next = 25;
                return this._routing.get(keys.routingKey.uint8Array());

              case 25:
                res = _context5.sent;
                return _context5.abrupt("return", this._unmarshalData(res));

              case 29:
                _context5.prev = 29;
                _context5.t1 = _context5["catch"](21);
                log.error(_context5.t1);
                throw _context5.t1;

              case 33:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[6, 13], [21, 29]]);
      }));

      function _getPublished(_x10) {
        return _getPublished2.apply(this, arguments);
      }

      return _getPublished;
    }()
  }, {
    key: "_unmarshalData",
    value: function _unmarshalData(data) {
      try {
        return ipns__namespace.unmarshal(data);
      } catch (err) {
        throw errCode__default["default"](err, 'ERR_INVALID_RECORD_DATA');
      }
    }
  }, {
    key: "_updateOrCreateRecord",
    value: function () {
      var _updateOrCreateRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(privKey, value, lifetime, peerId) {
        var errMsg, getPublishedOptions, record, _errMsg5, seqNumber, entryData, _errMsg6, data, _errMsg7;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (PeerId__default["default"].isPeerId(peerId)) {
                  _context6.next = 4;
                  break;
                }

                errMsg = 'peerId received is not valid';
                log.error(errMsg);
                throw errCode__default["default"](new Error(errMsg), 'ERR_INVALID_PEER_ID');

              case 4:
                getPublishedOptions = {
                  checkRouting: true
                };
                _context6.prev = 5;
                _context6.next = 8;
                return this._getPublished(peerId, getPublishedOptions);

              case 8:
                record = _context6.sent;
                _context6.next = 17;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](5);

                if (!(_context6.t0.code !== ERR_NOT_FOUND)) {
                  _context6.next = 17;
                  break;
                }

                _errMsg5 = "unexpected error when determining the last published IPNS record for ".concat(peerId.id, " ").concat(_context6.t0.stack);
                log.error(_errMsg5);
                throw errCode__default["default"](new Error(_errMsg5), 'ERR_DETERMINING_PUBLISHED_RECORD');

              case 17:
                seqNumber = 0;

                if (record && record.sequence !== undefined) {
                  seqNumber = !equals.equals(record.value, value) ? BigInt(record.sequence) + BigInt(1) : BigInt(record.sequence);
                }

                _context6.prev = 19;
                _context6.next = 22;
                return ipns__namespace.create(privKey, value, seqNumber, lifetime);

              case 22:
                entryData = _context6.sent;
                _context6.next = 30;
                break;

              case 25:
                _context6.prev = 25;
                _context6.t1 = _context6["catch"](19);
                _errMsg6 = "ipns record for ".concat(value, " could not be created");
                log.error(_context6.t1);
                throw errCode__default["default"](new Error(_errMsg6), 'ERR_CREATING_IPNS_RECORD');

              case 30:
                _context6.prev = 30;
                data = ipns__namespace.marshal(entryData);
                _context6.next = 34;
                return this._datastore.put(ipns__namespace.getLocalKey(peerId.id), data);

              case 34:
                log("ipns record for ".concat(toString.toString(value, 'base32'), " was stored in the datastore"));
                return _context6.abrupt("return", entryData);

              case 38:
                _context6.prev = 38;
                _context6.t2 = _context6["catch"](30);
                _errMsg7 = "ipns record for ".concat(value, " could not be stored in the datastore");
                log.error(_errMsg7);
                throw errCode__default["default"](new Error(_errMsg7), 'ERR_STORING_IN_DATASTORE');

              case 43:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 11], [19, 25], [30, 38]]);
      }));

      function _updateOrCreateRecord(_x11, _x12, _x13, _x14) {
        return _updateOrCreateRecord2.apply(this, arguments);
      }

      return _updateOrCreateRecord;
    }()
  }]);

  return IpnsPublisher;
}();

IpnsPublisher.defaultRecordLifetime = defaultRecordLifetime;
exports.IpnsPublisher = IpnsPublisher;